import { ReactNode, isValidElement } from "react";
import type { SanitizedChildrenSharedProps } from "./SanitizedChildren.props";

/**
 * Recursively wraps children in span if string.
 *
 * We need to do this so that if users use chrome's built in translations, the site doesnt crash.
 * To add translations, chrome adds "font" elements to the dom which are not added to react's virtual-dom, so
 * when react re-renders the page there is a mismatch between what the vdom thinks is on the dom, and what is actually on the dom.
 *
 * see: https://dev.to/ivanturashov/preventing-react-crashes-handling-google-translate-5bi0 for more info
 *
 * @param children children of button
 * @returns children of button wrapped in span if string
 */
function sanitizeInvalidChildren(
  children: SanitizedChildrenSharedProps["children"],
  index: number
): ReactNode | ReactNode[] {
  if (Array.isArray(children)) {
    return children.map((child, index) =>
      sanitizeInvalidChildren(child, index)
    );
  }
  if (!isValidElement(children)) {
    return <span key={`sanitized-child-${index}`}>{children}</span>;
  }
  return children;
}
export default function SanitizedChildren({
  children,
}: SanitizedChildrenProps): JSX.Element {
  return <>{sanitizeInvalidChildren(children, 0)}</>;
}

export type SanitizedChildrenProps = SanitizedChildrenSharedProps & {
  // Add any web specific props here.
};
